import Countries from './Countries.js';
export default Countries;
